module.exports = __webpack_public_path__ + "media/images/icons/outlined/bell-241c41120e7954ad22d66b10ff1241de.svg";